module.exports = __webpack_public_path__ + "static/media/img_card_locked.615ab17a.jpg";